/* ==========================================================================
   Casemira - Vidéos de fiche produit (C2, lot B)          25/08/2026
   --------------------------------------------------------------------------
   Un seul lecteur par page, un seul <video>, source injectée à l'ouverture et
   vidée à la fermeture. Remplace les trois scripts inline des gabarits
   handmade-carpet-decor, magic-home-2 et outdoor-2.

   ★ VAGUE 3, trois ajouts :
   1. DURÉE RÉELLE. Plus rien n'est écrit en dur dans le Liquid. Après le
      chargement complet de la page, en temps mort (`requestIdleCallback`), un
      <video preload="metadata"> temporaire lit la durée de chaque source, une
      à la fois, et l'écrit dans la carte ET dans la légende du lecteur. Le
      résultat est mémorisé par URL dans `sessionStorage`. Tant que la durée est
      inconnue, la zone reste vide : pas de faux « 20 sec ».
   2. MODE CINÉMA MOBILE. Sous 750 px (et en paysage téléphone), le lecteur est
      plein écran sur fond marine, `controls` natif retiré, contrôles maison :
      pause centrale, barre de progression, temps restant, son, plein écran,
      qui s'effacent après 2 s d'inactivité.
   3. MODE AMBIANCE. Les cartes `data-mode="ambient"` (Zoom matière) jouent en
      muet, en boucle, sans aucun contrôle : un tap sur la vidéo ferme.

   Desktop : rien ne change. `controls` natif, lecteur centré, seule la durée
   de la légende devient exacte.

   ★ VAGUE 4, quatre changements :
   1. SORTIE FACILE. Un clic ou un tap n'importe où en dehors de la vidéo et de
      ses contrôles ferme le lecteur, desktop comme mobile (le voile était en
      réalité couvert par `__frame` : son écoute ne recevait rien).
   2. BOUTON RETOUR. Sur mobile, l'ouverture empile un état `{cmVideo:true}` ;
      `popstate` ferme le lecteur au lieu de quitter la fiche, et une fermeture
      par un autre geste dépile cet état, sans double fermeture.
   3. MODE AMBIANCE. Le tap sur la vidéo ne ferme plus (il coupait la
      contemplation) : on ferme comme partout, à côté.
   4. RATIO ROBUSTE. `--cm-stage-ratio` est réappliqué à l'ouverture dès que
      `readyState >= 1`, et sur `loadeddata` en plus de `loadedmetadata`.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__csmVideos) return;
  window.__csmVideos = true;

  var MOBILE = '(max-width: 749px), (orientation: landscape) and (max-height: 480px) and (pointer: coarse)';
  var DRAG_DISTANCE = 80; /* px */
  var DRAG_VELOCITY = 0.5; /* px/ms */
  var CTRL_HIDE = 2000; /* ms d'inactivité avant l'effacement des contrôles */
  /* ★ VAGUE 4 : durée de sortie, jumelle de --cm-video-dur-close (260 ms) dans
     assets/casemira-videos.css. Le panneau ne sort de l'arbre qu'après. */
  var EXIT_MS = 260;
  var DRAG_SLOP = 6; /* px au-delà desquels un geste n'est plus un tap */
  var ROT_MS = 2500; /* ms d'affichage de « Tournez votre téléphone » */
  var PROBE_TIMEOUT = 12000; /* ms avant d'abandonner la lecture d'une durée */
  var KEY_DUR = 'csm-video-durations';
  var KEY_ROT = 'csm-video-rotate-seen';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  /* ---- Mémoire de session : sessionStorage peut être refusé (Safari privé,
     iframe tierce). Toute lecture ou écriture est donc gardée. ------------- */
  function readStore() {
    try {
      return JSON.parse(window.sessionStorage.getItem(KEY_DUR)) || {};
    } catch (e) {
      return {};
    }
  }
  function writeStore(o) {
    try {
      window.sessionStorage.setItem(KEY_DUR, JSON.stringify(o));
    } catch (e) {
      /* tant pis : on relira les métadonnées à la prochaine page */
    }
  }

  /* « 1 min 40 », « 6 s », « 20 s ». Les secondes sont sur deux chiffres dès
     qu'il y a des minutes, sinon « 1 min 5 » se lit mal. Troncature et non
     arrondi : sur desktop la légende est collée au minuteur natif, qui tronque
     lui aussi (une source de 100,7 s affiche « 1:40 », pas « 1:41 »). */
  function formatDuration(sec) {
    var s = Math.floor(sec);
    if (!isFinite(s) || s <= 0) return '';
    if (s < 60) return s + ' s';
    var m = Math.floor(s / 60);
    var r = s % 60;
    if (!r) return m + ' min';
    return m + ' min ' + (r < 10 ? '0' + r : r);
  }

  /* Temps restant du lecteur : « -1:14 ». */
  function clock(sec) {
    var s = Math.max(0, Math.floor(sec));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return '-' + m + ':' + (r < 10 ? '0' + r : r);
  }

  ready(function () {
    var wrap = document.querySelector('.csm-videos');
    var player = document.getElementById('csm-video-player');
    if (!player) return;

    /* ★ VAGUE 10 C3 · LES DÉCLENCHEURS SONT CHERCHÉS DANS TOUT LE DOCUMENT.
       Jusqu'ici ils devaient être des `.csm-video-card` DANS `.csm-videos` :
       le lecteur ne savait ouvrir que les vignettes de la liste qui le
       précède. Depuis la vague 10, le bandeau de collection porte un bouton
       « Voir le film » qui n'est pas une vignette et ne vit pas dans cette
       liste (`snippets/casemira-collection-hero.liquid`).

       Le sélecteur devient donc `[data-csm-video]`, l'attribut que les
       vignettes portaient DÉJÀ : rien à ajouter à la fiche produit, et le
       lecteur reste ce qu'il est - un singleton de page qui ouvre ce qu'on lui
       donne. La liste, elle, devient facultative (`lecteur_seul`). */
    var cards = [].slice.call(document.querySelectorAll('[data-csm-video]'));
    if (!cards.length) return;

    var video = player.querySelector('.csm-video-player__video');
    var box = player.querySelector('.csm-video-player__box');
    var stage = player.querySelector('.csm-video-player__stage');
    var elTitle = player.querySelector('.csm-video-player__title');
    var elDuration = player.querySelector('.csm-video-player__duration');
    var elText = player.querySelector('.csm-video-player__text');
    var elAlso = player.querySelector('.csm-video-player__also');
    var elCapTitle = player.querySelector('.csm-video-player__caption-title');
    var elCapDur = player.querySelector('.csm-video-player__caption-duration');
    var elCapSep = player.querySelector('.csm-video-player__caption-sep');
    var closeBtn = player.querySelector('.csm-video-player__close');

    var ppBtn = player.querySelector('.csm-video-player__pp');
    var soundBtn = player.querySelector('.csm-video-player__sound');
    var fullBtn = player.querySelector('.csm-video-player__full');
    var restEl = player.querySelector('.csm-video-player__rest');
    var bar = player.querySelector('.csm-video-player__bar');
    var barFill = bar ? bar.querySelector('i') : null;
    var rot = player.querySelector('.csm-video-player__rot');

    var isOpen = false;
    var opener = null;
    var current = null;
    var cinema = false;
    var mode = 'film';
    var closeToken = 0;
    var hideTimer = 0;
    var rotTimer = 0;
    var rotActive = false;

    /* Le lecteur doit échapper aux ancêtres transformés (Swiper de la galerie) :
       sinon `position: fixed` se cale sur la colonne produit et le haut de la
       modale passe derrière l'en-tête. Report du correctif de l'ancien bloc. */
    if (player.parentNode !== document.body) document.body.appendChild(player);

    /* ---- Verrou de défilement : overflow sur <html>, jamais fixed sur body -- */
    function lockScroll() {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--csm-video-sbw', sbw + 'px');
      document.documentElement.classList.add('csm-video-locked');
    }
    function unlockScroll() {
      document.documentElement.classList.remove('csm-video-locked');
      document.documentElement.style.removeProperty('--csm-video-sbw');
    }

    /* ======================================================================
       1 · Durées réelles
       ====================================================================== */
    function applyDuration(card, txt) {
      card.dataset.duration = txt;
      var meta = card.querySelector('.csm-video-card__meta');
      if (meta) meta.textContent = txt;
      if (current === card) {
        elDuration.textContent = txt;
        elCapDur.textContent = txt;
        elCapSep.hidden = !txt;
      }
    }

    /* Un <video> hors document, `preload="metadata"` : aucun octet d'image, la
       seule entête du fichier. Détruit dès la durée obtenue. */
    function probe(src, done) {
      var v = document.createElement('video');
      var settled = false;
      var timer = 0;

      function end(sec) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        try {
          v.removeAttribute('src');
          v.load();
        } catch (e) {
          /* rien à récupérer */
        }
        done(sec);
      }

      v.preload = 'metadata';
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.addEventListener('loadedmetadata', function () {
        end(isFinite(v.duration) ? v.duration : 0);
      });
      v.addEventListener('error', function () {
        end(0);
      });
      timer = window.setTimeout(function () {
        end(0);
      }, PROBE_TIMEOUT);
      v.src = src;
    }

    function fillDurations() {
      var store = readStore();
      var queue = [];

      cards.forEach(function (card) {
        var src = card.dataset.src;
        if (!src) return;
        if (store[src]) {
          applyDuration(card, formatDuration(store[src]));
          return;
        }
        if (queue.indexOf(src) === -1) queue.push(src);
      });

      /* Une source à la fois : deux téléchargements d'entête en parallèle sur
         un réseau mobile, c'est déjà de la concurrence pour la fiche. */
      (function next() {
        var src = queue.shift();
        if (!src) return;
        probe(src, function (sec) {
          if (sec) {
            store[src] = sec;
            writeStore(store);
            cards.forEach(function (c) {
              if (c.dataset.src === src) applyDuration(c, formatDuration(sec));
            });
          }
          next();
        });
      })();
    }

    /* Après le chargement complet de la page, et seulement en temps mort : la
       durée est un détail de légende, elle ne doit rien coûter au LCP. */
    function scheduleDurations() {
      var run = function () {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(fillDurations, { timeout: 3000 });
        } else {
          window.setTimeout(fillDurations, 1200);
        }
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }
    scheduleDurations();

    /* ======================================================================
       2 · Contenu du lecteur
       ====================================================================== */
    function fill(card) {
      var d = card.dataset;
      elTitle.textContent = d.title;
      elDuration.textContent = d.duration || '';
      elText.textContent = d.text || '';
      elCapTitle.textContent = d.title;
      elCapDur.textContent = d.duration || '';
      /* Sans durée (pas encore lue, ou source illisible), le point médian n'a
         rien à séparer. */
      elCapSep.hidden = !d.duration;

      var other = cards.length === 2 ? cards[cards.indexOf(card) === 0 ? 1 : 0] : null;
      if (other) {
        elAlso.textContent = 'Voir aussi : ' + other.dataset.title;
        elAlso.hidden = false;
        elAlso.__target = other;
      } else {
        elAlso.hidden = true;
        elAlso.__target = null;
      }
    }

    function load(card, autoplay) {
      if (video.getAttribute('src') !== card.dataset.src) {
        video.setAttribute('src', card.dataset.src);
      }
      var ambient = cinema && mode === 'ambient';
      /* Sur mobile, les contrôles natifs cèdent la place aux nôtres ; en mode
         ambiance il n'y a aucun contrôle du tout. Desktop : inchangé. */
      video.controls = !cinema;
      video.loop = ambient ? true : card.dataset.loop === '1';
      video.muted = ambient;
      player.dataset.muted = video.muted ? '1' : '0';
      video.preload = autoplay ? 'auto' : 'metadata';
      if (barFill) barFill.style.width = '0%';
      if (restEl) restEl.textContent = '';

      if (autoplay) {
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            /* Le son a été refusé (politique d'autoplay) : on retombe sur une
               lecture muette plutôt que sur une image fixe, et le bouton son
               dit la vérité. */
            video.muted = true;
            player.dataset.muted = '1';
            var q = video.play();
            if (q && q.catch) q.catch(function () {});
          });
        }
      }
    }

    /* Le cadre épouse le ratio réel de la source (desktop : plus de bandes
       latérales sur une vidéo carrée ou verticale ; mobile : la scène se pose
       bord à bord au vrai ratio).

       ★ VAGUE 4 · POURQUOI RAPH VOYAIT ENCORE DES BANDES ET PAS PLAYWRIGHT
       Le ratio n'était appliqué qu'à `loadedmetadata`. Or, sur desktop, le
       survol de la carte charge déjà la source en `preload="metadata"` : à
       l'instant du clic, le <video> porte DÉJÀ la même `src` et ses
       métadonnées (`readyState >= 1`). `open()` retirait alors
       `--cm-stage-ratio`, et `load()`, qui ne réattache la source que si elle
       change, n'en changeait pas : AUCUN nouvel événement n'était émis, et le
       cadre restait sur son 16/9 par défaut. Sur une source 638 x 480 (Zoom
       matière, ratio 1,33) cela donne exactement les bandes latérales décrites.
       Playwright ne le voyait pas : son clic suit le survol de si près que les
       métadonnées arrivent APRÈS l'ouverture, et l'événement corrigeait tout,
       d'où le cadre 877 x 660 mesuré par c2-ratio.mjs.

       Trois filets désormais : `loadedmetadata`, `loadeddata` (au cas où les
       métadonnées seraient déjà en cache au moment de l'écoute), et une
       application immédiate à l'ouverture dès que `readyState >= 1`. */
    function applyRatio() {
      if (video.videoWidth && video.videoHeight) {
        box.style.setProperty('--cm-stage-ratio', (video.videoWidth / video.videoHeight).toFixed(4));
      }
    }
    video.addEventListener('loadedmetadata', applyRatio);
    video.addEventListener('loadeddata', applyRatio);
    /* Safari iOS : videoWidth/videoHeight peuvent encore valoir 0 a
       loadedmetadata et n'etre connus qu'a `resize` (evenement emis quand les
       dimensions intrinseques changent), `canplay` ou `playing`. Sans cela la
       scene restait en 16/9 et une video 4/3 s'affichait en petit, cernee de
       noir (constate par Raph sur iPhone le 25/08). */
    video.addEventListener('resize', applyRatio);
    video.addEventListener('canplay', applyRatio);
    video.addEventListener('playing', applyRatio);
    video.addEventListener('timeupdate', applyRatio, { once: true });

    /* À l'ouverture : si la source en place est bien celle de la carte et que
       ses dimensions sont connues, on applique tout de suite ; sinon on repart
       du 16/9 par défaut et on laisse les événements faire leur travail. */
    function syncRatio(card, reset) {
      if (video.getAttribute('src') === card.dataset.src && video.readyState >= 1 && video.videoWidth) {
        applyRatio();
        return;
      }
      if (reset) box.style.removeProperty('--cm-stage-ratio');
    }

    /* ======================================================================
       3 · Contrôles maison (mode cinéma, `film`)
       ====================================================================== */
    function setCtrl(on) {
      window.clearTimeout(hideTimer);
      if (rotActive) {
        player.dataset.ctrl = 'off';
        return;
      }
      player.dataset.ctrl = on ? 'on' : 'off';
      /* En pause, les contrôles restent : rien ne bouge, rien à masquer. */
      if (on && !video.paused) {
        hideTimer = window.setTimeout(function () {
          player.dataset.ctrl = 'off';
        }, CTRL_HIDE);
      }
    }

    function maybeRotateHint() {
      var seen = false;
      try {
        seen = window.sessionStorage.getItem(KEY_ROT) === '1';
      } catch (e) {
        /* stockage refusé : on montre l'indication, une fois par ouverture */
      }
      if (seen || !rot) return;
      try {
        window.sessionStorage.setItem(KEY_ROT, '1');
      } catch (e) {}

      rotActive = true;
      rot.hidden = false;
      player.dataset.ctrl = 'off';
      window.clearTimeout(hideTimer);
      window.clearTimeout(rotTimer);
      rotTimer = window.setTimeout(function () {
        rot.hidden = true;
        rotActive = false;
        setCtrl(true);
      }, ROT_MS);
    }

    function clearRotateHint() {
      window.clearTimeout(rotTimer);
      rotActive = false;
      if (rot) rot.hidden = true;
    }

    if (ppBtn) {
      ppBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
        setCtrl(true);
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        player.dataset.muted = video.muted ? '1' : '0';
        soundBtn.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
        setCtrl(true);
      });
    }

    if (fullBtn) {
      fullBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        /* iOS ne connaît que le plein écran natif du <video> ; ailleurs c'est
           la scène entière qui passe en plein écran, contrôles maison compris. */
        if (typeof video.webkitEnterFullscreen === 'function') {
          try {
            video.webkitEnterFullscreen();
            return;
          } catch (err) {
            /* on retombe sur l'API standard */
          }
        }
        if (stage && stage.requestFullscreen) {
          var r = stage.requestFullscreen();
          if (r && r.catch) r.catch(function () {});
        }
        setCtrl(true);
      });
    }

    if (bar) {
      bar.addEventListener('click', function (e) {
        if (!cinema || mode !== 'film' || !isFinite(video.duration) || !video.duration) return;
        e.stopPropagation();
        var r = bar.getBoundingClientRect();
        var ratio = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        try {
          video.currentTime = ratio * video.duration;
        } catch (err) {
          /* source non cherchable : on ne fait rien */
        }
        setCtrl(true);
      });
    }

    video.addEventListener('timeupdate', function () {
      if (!isFinite(video.duration) || !video.duration) return;
      if (barFill) barFill.style.width = ((video.currentTime / video.duration) * 100).toFixed(2) + '%';
      if (restEl) restEl.textContent = clock(video.duration - video.currentTime);
    });
    video.addEventListener('play', function () {
      player.dataset.playing = '1';
      if (cinema && mode === 'film' && player.dataset.ctrl === 'on') setCtrl(true);
    });
    video.addEventListener('pause', function () {
      player.dataset.playing = '0';
      window.clearTimeout(hideTimer);
      if (cinema && mode === 'film' && !rotActive) player.dataset.ctrl = 'on';
    });

    /* Un tap sur la vidéo réveille les contrôles, sans jamais mettre en pause.
       ★ VAGUE 4 : en mode ambiance il ne ferme PLUS. Fermer sous le doigt
       pendant qu'on regarde la matière de près était le contraire du geste
       attendu ; la sortie se fait maintenant comme partout, à côté de l'image
       (voir la section 5 bis). */
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (!cinema || mode !== 'film') return;
        if (bar && bar.contains(e.target)) return;
        if (rotActive) return;
        setCtrl(true);
      });
    }

    /* ======================================================================
       4 · Ouverture / fermeture
       ====================================================================== */
    function prepare(card) {
      current = card;
      cinema = isMobile();
      mode = card.dataset.mode === 'ambient' ? 'ambient' : 'film';
      player.dataset.mode = mode;
      player.dataset.cinema = cinema ? '1' : '0';
      player.dataset.playing = '1';
      player.dataset.ctrl = 'off';
    }

    /* ---- ★ VAGUE 4 · Le bouton retour du téléphone -----------------------
       Sans cela, le premier réflexe d'un utilisateur pris dans un lecteur plein
       écran (le retour Android, ou le glissement depuis le bord sur iOS) le
       fait QUITTER la fiche produit. On empile donc un état à l'ouverture, et
       `popstate` devient une fermeture de plus.

       `pushed` dit si l'état empilé est encore le nôtre. Une fermeture par un
       autre geste le dépile (`history.back()`), une fermeture PAR le retour
       remet le drapeau à faux AVANT d'appeler `close()` : jamais deux
       fermetures, jamais un `back()` qui ferait reculer d'une vraie page. */
    var pushed = false;

    function pushHistory() {
      if (pushed) return;
      try {
        window.history.pushState({ cmVideo: true }, '');
        pushed = true;
      } catch (e) {
        pushed = false; /* navigateur qui refuse : les autres sorties restent */
      }
    }
    function popHistory() {
      if (!pushed) return;
      pushed = false;
      try {
        window.history.back();
      } catch (e) {
        /* rien à récupérer */
      }
    }
    window.addEventListener('popstate', function () {
      if (!pushed) return;
      pushed = false;
      if (isOpen) close();
    });

    function open(card) {
      if (isOpen) {
        clearRotateHint();
        prepare(card);
        fill(card);
        load(card, true);
        syncRatio(card, false);
        if (cinema && mode === 'film') setCtrl(true);
        return;
      }
      opener = card;
      prepare(card);
      fill(card);
      /* Le ratio AVANT la première peinture : si le survol a déjà chargé les
         métadonnées, le cadre s'ouvre directement au bon format. */
      syncRatio(card, true);
      player.hidden = false;
      player.setAttribute('aria-hidden', 'false');
      lockScroll();
      /* Un cadre pour que la classe d'ouverture produise bien une transition. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          player.classList.add('is-open');
        });
      });
      isOpen = true;
      load(card, true);
      syncRatio(card, false);
      /* Le retour ne doit ramener sur la fiche que depuis le lecteur mobile :
         sur desktop, le retour du navigateur garde son sens habituel. */
      if (cinema) pushHistory();
      hideThemeTab(true);
      if (cinema && mode === 'film') {
        setCtrl(true);
        maybeRotateHint();
      }
      closeBtn.focus({ preventScroll: true });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      current = null;
      player.classList.remove('is-open', 'is-dragging');
      box.style.transform = '';
      clearRotateHint();
      window.clearTimeout(hideTimer);
      player.dataset.ctrl = 'off';
      video.pause();
      video.removeAttribute('src');
      video.load();
      unlockScroll();
      hideThemeTab(false);
      if (document.fullscreenElement && document.exitFullscreen) {
        var x = document.exitFullscreen();
        if (x && x.catch) x.catch(function () {});
      }
      /* Si l'état empilé est encore le nôtre, on le dépile. Quand la fermeture
         VIENT du retour, `pushed` est déjà faux : aucun appel. */
      popHistory();

      /* Le panneau ne disparaît de l'arbre qu'une fois la sortie terminée. Le
         jeton évite qu'une réouverture rapide se fasse masquer par la sortie
         de la fermeture précédente. */
      closeToken += 1;
      var token = closeToken;
      window.setTimeout(function () {
        if (token !== closeToken || isOpen) return;
        player.hidden = true;
        player.setAttribute('aria-hidden', 'true');
      }, EXIT_MS + 40);

      if (opener) {
        opener.focus({ preventScroll: true });
        opener = null;
      }
    }

    /* ── L'onglet flottant du thème, et tout ce qui flotte avec lui ──────────
       ★ VAGUE 11 C3, point 2 · LE LECTEUR S'HABILLE PAREIL SUR LES DEUX PAGES.

       LE DÉFAUT, décrit par Raph le 27/08 : le lecteur cinéma ouvert depuis la
       carte du bandeau de collection (« Voir le film », savoir-faire artisanal)
       ne se comportait pas comme celui des fiches produit. La bulle « M » du
       chat maison continuait de flotter par-dessus le voile.

       LA CAUSE, mesurée : la profondeur du chat était corrigée dans
       `casemira-pdp-layout.css`, sous un sélecteur `body.product-template`. Les
       trois éléments qui se peignent vraiment (`.lanceur`, `.invit`, `.apercu`)
       sont posés par le widget en `position: fixed` avec `z-index: 9988`, en
       style EN LIGNE. Sur une fiche, la règle les redescendait au palier
       `--z-sticky` (100), donc sous le voile du lecteur (`--z-modal`, 400). Sur
       une collection, le sélecteur ne mordait pas : 9988 restait, et 9988 passe
       devant tout.

       LA CORRECTION EST UNE CLASSE SUR `<html>`, `csm-video-open`, posée par ce
       fichier-ci et lue par sa propre feuille de style. Deux raisons de la
       mettre là plutôt que d'étendre le sélecteur de la fiche : c'est le lecteur
       qui sait quand il est ouvert, et n'importe quelle page qui l'inclut en
       hérite - collection, fiche, et celles qui viendront - sans qu'on ait à
       recenser les gabarits. Le verrou de défilement (`csm-video-locked`) suit
       déjà exactement ce chemin.

       La FENÊTRE du chat (`.panneau`) n'est pas touchée, ici comme sur la
       fiche : une conversation ouverte reste au-dessus de tout. */
    function hideThemeTab(hide) {
      var tab = document.querySelector('.thTabBtn');
      if (tab) tab.style.display = hide ? 'none' : '';
      document.documentElement.classList.toggle('csm-video-open', !!hide);
    }

    /* ======================================================================
       5 · Écoutes
       ====================================================================== */
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        open(card);
      });
      /* Survol : on charge les métadonnées de la source, si rien ne joue. */
      card.addEventListener('pointerenter', function (e) {
        /* `player.hidden` et pas seulement `isOpen` : quand le lecteur se ferme,
           le curseur se retrouve au-dessus de la carte et le navigateur renvoie
           un `pointerenter`, ce qui rechargeait la source qu'on venait de vider.
           Le panneau reste `hidden = false` le temps du fondu : on laisse le
           geste de fermeture aller a son terme. */
        if (e.pointerType !== 'mouse' || isOpen || !player.hidden || !video.paused) return;
        if (video.getAttribute('src') === card.dataset.src) return;
        video.preload = 'metadata';
        video.setAttribute('src', card.dataset.src);
      });
    });

    [].slice.call(player.querySelectorAll('[data-csm-video-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* ---- ★ VAGUE 4 · 5 bis · SORTIE FACILE : un clic à côté ferme ---------
       Le voile portait bien `data-csm-video-close`, mais il ne recevait aucun
       clic : `.csm-video-player__frame`, déclaré après lui et posé lui aussi en
       `inset: 0`, le recouvre entièrement. Cliquer dans la zone sombre ne
       fermait donc rien, ni sur desktop ni sur mobile, et l'utilisateur se
       retrouvait enfermé dès qu'il ne trouvait pas la croix.

       L'écoute est posée sur le lecteur entier et ne laisse passer que deux
       choses : la vidéo avec ses contrôles (`__stage`), et les boutons, qui
       ont chacun leur propre sens (la croix ferme déjà, « Voir aussi » change
       de vidéo). Tout le reste ferme : voile, marges, légende, titre,
       paragraphe, poignée. Aucun de ces éléments n'arrête la propagation, et
       les contrôles qui le font (pause, son, plein écran, barre) sont de toute
       façon dans `__stage`. */
    player.addEventListener('click', function (e) {
      if (!isOpen) return;
      /* Un glissement retenu sous le seuil se termine aussi par un `click` :
         ce n'est pas un tap, il ne doit pas fermer. */
      if (dragMoved) {
        dragMoved = false;
        return;
      }
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.csm-video-player__stage')) return;
      if (t.closest('button')) return;
      close();
    });

    elAlso.addEventListener('click', function () {
      if (elAlso.__target) open(elAlso.__target);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    /* ---- Glissement vers le bas (mécanique de la vague 1, conservée) ------- */
    var startY = 0;
    var startT = 0;
    var dragging = false;
    var dragId = null;
    /* ★ VAGUE 4 : vrai/faux « ce geste a bougé », lu par la fermeture au clic. */
    var dragMoved = false;

    box.addEventListener('pointerdown', function (e) {
      if (!isOpen || !isMobile()) return;
      /* Ni sur la vidéo (le tap y a son propre sens), ni sur un bouton : la
         capture de pointeur détournerait leur clic. */
      if (e.target.closest('.csm-video-player__stage')) return;
      if (e.target.closest('button')) return;
      dragging = true;
      dragMoved = false;
      dragId = e.pointerId;
      startY = e.clientY;
      startT = e.timeStamp;
      player.classList.add('is-dragging');
      box.setPointerCapture(e.pointerId);
    });

    box.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = Math.max(0, e.clientY - startY);
      if (dy > DRAG_SLOP) dragMoved = true;
      box.style.transform = 'translateY(' + dy + 'px)';
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      player.classList.remove('is-dragging');
      if (dragId !== null && box.releasePointerCapture) {
        try {
          box.releasePointerCapture(dragId);
        } catch (err) {
          /* déjà relâché */
        }
      }
      dragId = null;
      var dy = Math.max(0, e.clientY - startY);
      var dt = Math.max(1, e.timeStamp - startT);
      if (dy > DRAG_DISTANCE || dy / dt > DRAG_VELOCITY) {
        close();
      } else {
        /* Sous le seuil, la feuille remonte à sa place. */
        box.style.transform = '';
      }
    }
    box.addEventListener('pointerup', endDrag);
    box.addEventListener('pointercancel', endDrag);

    /* ---- Report outdoor : la section « Savoir-faire » redondante ------------
       L'ancien bloc `custom_liquid_dHaidd` masquait la section de contenu
       « Savoir-faire » dès qu'une vidéo zoom existait, la carte la remplaçant.
       Comportement conservé, et seulement pour ce gabarit (attribut posé par
       le snippet). À remplacer par un retrait propre de la section dans le
       gabarit outdoor-2 quand Raph le décidera. */
    if (wrap && wrap.dataset.hideLegacySavoirFaire === 'true') {
      var hideSavoirFaire = function () {
        [].slice.call(document.querySelectorAll('.section--custom-content')).forEach(function (s) {
          var h = s.querySelector('h2');
          if (h && h.textContent.trim().indexOf('Savoir-faire') !== -1) {
            var host = s.closest('.shopify-section');
            if (host) host.style.display = 'none';
          }
        });
      };
      hideSavoirFaire();
      window.setTimeout(hideSavoirFaire, 500);
      window.setTimeout(hideSavoirFaire, 1500);
    }
  });
})();
